const invoiceEventBus = window && window.invoiceEventBus || {}
const client = {
    on(event, callback) {
        return invoiceEventBus.on && invoiceEventBus.on(event, callback);
    },
    dispatch(event, data) {
        invoiceEventBus.dispatch && invoiceEventBus.dispatch(event, data);
    },
    remove(event, callback) {
        invoiceEventBus.remove && invoiceEventBus.remove(event, callback);
    }
}

export default client;